import React from 'react';

import LazyImage from '@components/LazyImage';
import TimeAgo from '@components/TimeAgo';
import { useAppContext } from '@contexts/AppContext';
import { article_path } from '@routes';
import { getArticleImgSrc } from '@utils/images';

import { Article } from '../../../interfaces/homepage';
import IconProTagThumbnail from '../../Images/Rebranding/IconProTagThumbnail';

interface ArticleProps {
  article: Article;
}

const ProArticleItem = ({ article: { id, picture, publishedAt, slug, title } }: ArticleProps) => {
  const { env } = useAppContext();

  return (
    <div className="flex flex-col pb-40 last:pb-0 sm:w-min sm:pb-0 last:sm:hidden last:md:flex">
      <a
        href={article_path(slug)}
        className="relative mb-8 block h-[calc((100vw-2rem)*9/16)] sm:mb-0 sm:h-[calc(257px*9/16)] sm:min-w-[257px]"
      >
        <IconProTagThumbnail className="absolute right-0 top-0" />
        <LazyImage
          className="m-auto block aspect-[16/9] h-auto w-full"
          src={getArticleImgSrc(id, picture, env)}
          sizes="(min-width: 768px) 250px, (min-width: 480px) 400px, 300px"
          wrapperClassName="h-full w-full"
        />
      </a>
      <div className="mt-8 sm:mt-12">
        <h2 className="pro-article-title m-0 font-suisse-works text-headline-xs text-black lg:text-headline-xxs">
          <a href={article_path(slug)} className="text-primary-black">
            {title}
          </a>
        </h2>
        <TimeAgo className="block text-grayscale-gray" date={publishedAt} />
      </div>
    </div>
  );
};

export default ProArticleItem;
